import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

import routes from "./routes";
import user from "./user";
import setting from "./setting";
import perm from "./perm";

export default new Vuex.Store({
  modules: {
    setting,
    routes,
    user,
    perm,
  },
});
